"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAdapter = void 0;
class BaseAdapter {
}
exports.BaseAdapter = BaseAdapter;
//# sourceMappingURL=base.adapter.js.map